import type { $Fetch } from 'nitropack';

import type { Announcement } from '~/models';

import type { DefaultFilter } from './filter';

interface Filter extends Partial<DefaultFilter> {
  description?: string;
  onlyActive?: boolean;
  disabled?: boolean;
}

export default class AnnouncementService {
  constructor(private fetch: $Fetch) {}

  async list(filter?: Filter): Promise<Announcement[]> {
    return await this.fetch<Announcement[]>('/announcements/', {
      query: filter
    });
  }
}
